import { useMutation, useQueryClient } from 'react-query';
import { toast } from 'sonner';

import { APIBaseChronos } from '../hosts';
import { QueryEntity } from '../types';
import useGetFetchConfig, { FetchMethod } from '../useGetFetchConfig';

interface UseDeletePendingInviteParams {
  inviteId: string;
}

export const useDeletePendingInvite = ({ matterId }: { matterId: string }) => {
  const { getFetchConfig } = useGetFetchConfig();
  const queryClient = useQueryClient();

  return useMutation<void, Error, UseDeletePendingInviteParams>(
    async ({ inviteId }: UseDeletePendingInviteParams) => {
      const fetchConfig = getFetchConfig({
        method: FetchMethod.DELETE,
      });

      const response = await fetch(
        `${APIBaseChronos}/api/matters/${matterId}/pending-invites/${inviteId}`,
        fetchConfig,
      );

      if (!response.ok) {
        throw new Error('Failed to remove pending invite');
      }
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: [QueryEntity.PendingInvites, { matterId }] });
        toast.success('Pending invite removed');
      },
      onError: () => {
        toast.error('Failed to remove pending invite. Please try again.');
      },
    },
  );
};
